import React, { FC } from 'react';

import { DescriptionTooltip } from './DescriptionTooltip';

interface TooltipWrapperProps {
  children: React.ReactNode;
  title?: React.ReactNode;
}

export const TooltipWrapper: FC<TooltipWrapperProps> = ({ children, title }) =>
  title ? (
    <DescriptionTooltip
      disableFocusListener
      enterTouchDelay={100}
      title={title}
    >
      <div>{children}</div>
    </DescriptionTooltip>
  ) : (
    <>{children}</>
  );
